<template>
    <div class="my-sod-eod-history">
        <v-container fluid class="pa-6">
            <SodEodFullReport />
        </v-container>
    </div>
</template>

<script>
import SodEodFullReport from '../../components/modules/SodEodFullReport.vue';

export default {
    name: 'MySodEodHistory',
    components: {
        SodEodFullReport,
    },
};
</script>
